import { Link } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import FormatPrice from "../../../properties/components/shared/PriceFormatter";
import FormatDateTime from "../../../../shared/utils/dateUtils";
import Cookies from "js-cookie";
import { MdDeleteOutline } from "react-icons/md";
import Swal from "sweetalert2";
import { BiEdit } from "react-icons/bi";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const MyPost = ({ statusCloseMap, SetStatusCloseMap }) => {
  const location = useLocation();

  useEffect(() => {
    const key = `scrollPosition_${location.pathname}`;
    const storedScrollPosition = parseInt(localStorage.getItem(key) || "0", 10);
    const handleScroll = () => localStorage.setItem(key, window.scrollY.toString());
    window.addEventListener("scroll", handleScroll);
    setTimeout(() => window.scrollTo(0, storedScrollPosition), 2500);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  const getToken = () => Cookies.get("jwt");

  const [DataAsset, setDataAsset] = useState([]);
  const [tempDisplayRemoveAssetID, setTempDisplayRemoveAssetID] = useState(null);

  function fetchData() {
    axios
      .get(`${process.env.REACT_APP_API}/asset/myassets`, {
        headers: { Authorization: `Bearer ${getToken()}`, "Content-Type": "multipart/form-data" },
      })
      .then((res) => setDataAsset(res.data.assets))
      .catch(() => {});
  }

  useEffect(() => { fetchData(); }, []);

  function handleRemoveMyAsset(assetId) {
    Swal.fire({
      title: "ยืนยันการลบโพสต์?",
      text: "คุณต้องการลบโพสต์!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34BFD9",
      cancelButtonColor: "#000",
      confirmButtonText: "ยืนยันการลบโพสต์",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(`${process.env.REACT_APP_API}/event/deleteAsset`, { asset_id: assetId }, { headers: { Authorization: `Bearer ${getToken()}` } })
          .then(() => {
            Swal.fire("สำเร็จ!", "ลบโพสต์สำเร็จ", "success");
            setTempDisplayRemoveAssetID(assetId);
            fetchData();
          })
          .catch(console.log);
      }
    });
  }

  function handleCloseAsset(id_asset) {
    Swal.fire({
      title: "ยืนยันการปิดการขาย",
      html: `
        <div class="mb-4 text-left">
          <label class="block mb-2 font-medium">เหตุผลในการปิดการขาย:</label>
          <div class="flex items-center mb-2"><input type="radio" id="sold" name="closeReason" value="ขายได้" class="mr-2" checked><label for="sold">ขายทรัพย์ได้แล้ว</label></div>
          <div class="flex items-center mb-2"><input type="radio" id="reserved" name="closeReason" value="ยกเลิก" class="mr-2"><label for="reserved">ยกเลิก ไม่ขายแล้ว</label></div>
          <div class="flex items-center mb-2"><input type="radio" id="reserved2" name="closeReason" value="ติดจอง" class="mr-2"><label for="reserved2">ติดจอง</label></div>
          <div class="flex items-center mb-2"><input type="radio" id="cancel" name="closeReason" value="ยกเลิก ไม่ขายแล้ว" class="mr-2"><label for="cancel">พักการขายออกไปก่อน</label></div>
          <div class="mt-3"><label class="block mb-2">รายละเอียดเพิ่มเติม (ถ้ามี):</label><textarea id="additionalDetails" class="w-full px-3 py-2 border rounded" rows="3"></textarea></div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonColor: "#34BFD9",
      cancelButtonColor: "#000",
      confirmButtonText: "ยืนยันการปิดการขาย",
      cancelButtonText: "ยกเลิก",
      preConfirm: () => {
        const reasonElement = document.querySelector('input[name="closeReason"]:checked');
        const additionalDetails = document.getElementById("additionalDetails").value;
        if (!reasonElement) { Swal.showValidationMessage("กรุณาเลือกเหตุผลในการปิดการขาย"); return false; }
        return { reason: reasonElement.value, details: additionalDetails };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { reason, details } = result.value;
        axios
          .post(`${process.env.REACT_APP_API}/event/soldAsset`, { asset_id: id_asset, reason, details }, { headers: { Authorization: `Bearer ${getToken()}` } })
          .then(() => { Swal.fire("สำเร็จ!", "ปิดการขายสำเร็จ", "success"); fetchData(); })
          .catch(() => Swal.fire("ผิดพลาด!", "ไม่สามารถปิดการขายได้", "error"));
      }
    });
  }

  function handleCancelCloseAsset(id_asset) {
    Swal.fire({
      title: "ยืนยันการยกเลิกปิดการขาย?",
      text: "คุณต้องการนำทรัพย์นี้กลับมาขายอีกครั้ง",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#34BFD9",
      cancelButtonColor: "#000",
      confirmButtonText: "ยืนยันการเปิดขายอีกครั้ง",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(`${process.env.REACT_APP_API}/event/cancelSoldAsset`, { asset_id: id_asset }, { headers: { Authorization: `Bearer ${getToken()}` } })
          .then(() => { Swal.fire("สำเร็จ!", "เปิดการขายอีกครั้งสำเร็จ", "success"); fetchData(); })
          .catch(() => Swal.fire("ผิดพลาด!", "ไม่สามารถเปิดการขายอีกครั้งได้", "error"));
      }
    });
  }

  const editPath = (type, id) => {
    const map = { house: "/house", condo: "/condo", land: "/land", commercial: "/commercial", townhouse: "/townhouse" };
    return `/edit${map[type] || ""}/${id}`;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 py-8 space-y-4 lg:pt-24">

        {/* ── Header ── */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5 py-4 flex items-center gap-3"
        >
          <Link to="/profiles">
            <div className="w-9 h-9 bg-gray-50 rounded-xl flex items-center justify-center border border-gray-100 hover:bg-gray-100 transition-colors flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </div>
          </Link>
          <div className="flex-1">
            <p className="text-xs text-gray-400 uppercase tracking-wider mb-0.5">โปรไฟล์</p>
            <h1 className="text-lg font-bold text-gray-900">ประกาศของฉัน</h1>
          </div>
          <span className="text-xs px-3 py-1.5 bg-blue-50 text-blue-600 font-semibold rounded-full">
            {DataAsset.length} โพสต์
          </span>
        </motion.div>

        {/* ── Grid ── */}
        {DataAsset.length === 0 ? (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.05 }}
            className="bg-white rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center justify-center py-16 gap-3 text-gray-400"
          >
            <div className="w-14 h-14 bg-gray-100 rounded-2xl flex items-center justify-center">
              <img src="https://cdn-icons-png.flaticon.com/512/2333/2333043.png" alt="" className="w-7 h-7 opacity-30" />
            </div>
            <p className="text-sm">คุณยังไม่มีโพสต์ที่ประกาศ</p>
            <Link to="/create/">
              <div className="px-4 py-2 bg-blue-600 text-white text-xs font-semibold rounded-xl hover:bg-blue-700 transition-colors mt-1">
                + ลงประกาศใหม่
              </div>
            </Link>
          </motion.div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {DataAsset.map((post, i) => (
              tempDisplayRemoveAssetID !== post.id && (
                <motion.article
                  key={post.id}
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.35, delay: i * 0.04 }}
                  className={`bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col ${post.status ? "opacity-40" : ""}`}
                >
                  {/* Image */}
                  <div className="relative h-44 overflow-hidden flex-shrink-0">
                    <img
                      src={post.images_url.AssetImagesURL[0]}
                      className="w-full h-full object-cover"
                      alt=""
                    />

                    {/* Edit + Delete */}
                    <div className="absolute top-2 left-2 flex gap-1.5">
                      <Link to={editPath(post.type, post.id)}>
                        <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm hover:bg-gray-50 transition-colors">
                          <BiEdit className="w-4 h-4 text-gray-600" />
                        </div>
                      </Link>
                    </div>
                    <div className="absolute top-2 right-2">
                      <button
                        onClick={() => handleRemoveMyAsset(post.id)}
                        className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center shadow-sm hover:bg-red-600 transition-colors"
                      >
                        <MdDeleteOutline className="w-4 h-4 text-white" />
                      </button>
                    </div>

                    {/* Sold overlay */}
                    {post.sold && (
                      <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                        <span className="text-white font-bold text-sm bg-black/50 px-3 py-1 rounded-full">ปิดการขายแล้ว</span>
                      </div>
                    )}
                  </div>

                  {/* Info */}
                  <div className="px-4 pt-3 pb-2 flex-1 flex flex-col">
                    <p className="text-sm font-semibold text-gray-900 leading-snug truncate">{post.title.slice(0, 32)}</p>
                    <p className="text-sm font-bold text-emerald-600 mt-0.5">
                      <FormatPrice number={post.sell_price ?? ""} suffix={post.sell_price ? " บาท" : ""} />
                    </p>
                    <p className="text-xs text-gray-400 mt-1 line-clamp-2">{post.description.slice(0, 60)}...</p>

                    {/* Rooms */}
                    {(post.rooms.Bedroom > 0 || post.rooms.Bathroom > 0) && (
                      <div className="flex gap-2 mt-2">
                        {post.rooms.Bedroom > 0 && (
                          <span className="flex items-center gap-1 text-xs bg-gray-50 border border-gray-100 rounded-full px-2 py-0.5 text-gray-500">
                            <img src="https://cdn-icons-png.flaticon.com/512/2642/2642252.png" className="w-3 h-3" alt="" />
                            {post.rooms.Bedroom}
                          </span>
                        )}
                        {post.rooms.Bathroom > 0 && (
                          <span className="flex items-center gap-1 text-xs bg-gray-50 border border-gray-100 rounded-full px-2 py-0.5 text-gray-500">
                            <img src="https://cdn-icons-png.flaticon.com/512/3565/3565091.png" className="w-3 h-3" alt="" />
                            {post.rooms.Bathroom}
                          </span>
                        )}
                      </div>
                    )}

                    <div className="mt-auto pt-3 border-t border-gray-50 flex items-center justify-between">
                      <time className="text-xs text-gray-400">
                        <FormatDateTime isoDateString={post.date} />
                      </time>
                      {/* Close/Reopen button */}
                      {!post.sold ? (
                        <button
                          onClick={() => handleCloseAsset(post.id)}
                          className="text-xs px-2.5 py-1 bg-red-50 text-red-500 border border-red-100 rounded-full hover:bg-red-100 transition-colors font-medium"
                        >
                          ปิดการขาย
                        </button>
                      ) : (
                        <button
                          onClick={() => handleCancelCloseAsset(post.id)}
                          className="text-xs px-2.5 py-1 bg-gray-50 text-gray-600 border border-gray-200 rounded-full hover:bg-gray-100 transition-colors font-medium"
                        >
                          เปิดขายอีกครั้ง
                        </button>
                      )}
                    </div>
                  </div>
                </motion.article>
              )
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyPost;
